import img00 from "../images/walking-beside-you-felt-like-flying-2.jpg";
import img01 from "../images/two-wolves-2.jpg";
import img02 from "../images/Artemis-2.jpg";
import img03 from "../images/In-the-ashes-circled-by-seeds2.jpg";
import img04 from "../images/untitled--2.jpg";
import img05 from "../images/warm-and-soft-moss-2.jpg";
import img1 from "../images/low-tide-2.jpg";
import img2 from "../images/little-dark2.jpg";
import img3 from "../images/lacquer-heart2.jpg";
import img4 from "../images/kiss-2.jpg";
import img5 from "../images/embrace-2.jpg";
import img6 from "../images/pollen-2.jpg";
import img7 from "../images/blue-shift2.jpg";
import img8 from "../images/calico-2.jpg";
import img9 from "../images/obsydian-2.jpg";
import img10 from "../images/untitled-12.jpg";
import img11 from "../images/foal-2.jpg";
import img12 from "../images/In-the-small-valley2.jpg";
import img13 from "../images/memoriam-2.jpg";
import img14 from "../images/dartmoor-2.jpg";
import img15 from "../images/pearl-2.jpg";
import img16 from "../images/untitled-2-2.jpg";
import img17 from "../images/koenji-2.jpg";
import img18 from "../images/by-my-side2.jpg";
import img19 from "../images/as-it-was-in-the-beginning2.jpg";
import img20 from "../images/untitled-32.jpg";
import img21 from "../images/two-2.jpg";
import img20_2 from "../images/untitled-3_2_32.jpg";

import { Link } from "react-router-dom";
import React, { useState } from "react";
import LazyLoad from "react-lazyload";

// Artwork data array
const artworks = [
  {
    id: "img00",
    image: img00,
    title: "Walking with you felt like flying",
    year: 2025,
    medium: "oil on canvas",
    dimensions: "30x40",
    price: "400€",
  },
  {
    id: "img01",
    image: img01,
    title: "Two wolves",
    year: 2025,
    medium: "oil on canvas",
    dimensions: "30x41",
    price: "400€",
  },
  {
    id: "img02",
    image: img02,
    title: "Artemis",
    year: 2025,
    medium: "oil on canvas",
    dimensions: "30x24",
    price: "280€",
  },
  {
    id: "img03",
    image: img03,
    title: "In the ashes circled by seeds",
    year: 2025,
    medium: "oil on canvas",
    dimensions: "30x21",
    price: "280€",
  },
  {
    id: "img04",
    image: img04,
    title: "Untitled",
    year: 2025,
    medium: "oil on canvas",
    dimensions: "23x17",
    price: "280€",
  },
  {
    id: "img05",
    image: img05,
    title: "Warn and soft moss",
    year: 2025,
    medium: "graphite on paper",
    dimensions: "30x21",
    price: "280€",
  },
  {
    id: "img1",
    image: img1,
    title: "Low Tide",
    year: 2024,
    medium: "oil on canvas",
    dimensions: "50x32",
    price: "£370",
    purchaseUrl: "https://buy.stripe.com/5kAbLgcW69tX7ug6op",
  },
  {
    id: "img2",
    image: img2,
    title: "Little dark",
    year: 2024,
    medium: "oil on canvas",
    dimensions: "25x25",
    price: "sold",
  },
  {
    id: "img3",
    image: img3,
    title: "Lacquer heart",
    year: 2023,
    medium: "oil on wood",
    dimensions: "32x19.5",
    price: "sold",
  },
  {
    id: "img4",
    image: img4,
    title: "Kiss",
    year: 2023,
    medium: "graphite",
    dimensions: "10x15",
    price: "sold",
  },
  {
    id: "img5",
    image: img5,
    title: "Embrace",
    year: 2023,
    medium: "oil on canvas board",
    dimensions: "25x30",
    price: "£200",
    purchaseUrl: "https://buy.stripe.com/28o9D8bS249DdSE28d",
  },
  {
    id: "img6",
    image: img6,
    title: "Pollen",
    year: 2024,
    medium: "oil on canvas",
    dimensions: "20x18",
    price: "£180",
    purchaseUrl: "https://buy.stripe.com/9AQcPke0afSl6qc5kq",
  },
  {
    id: "img7",
    image: img7,
    title: "Blue shift",
    year: 2024,
    medium: "oil on canvas board",
    dimensions: "18x18",
    price: "sold",
  },
  {
    id: "img8",
    image: img8,
    title: "Calico",
    year: 2023,
    medium: "oil on canvas",
    dimensions: "19x16",
    price: "sold",
  },
  {
    id: "img9",
    image: img9,
    title: "Obsydian",
    year: 2023,
    medium: "oil on canvas board",
    dimensions: "15x15",
    price: "£200",
    purchaseUrl: "https://buy.stripe.com/3csdTo6xI8pT01O5ks",
  },
  {
    id: "img10",
    image: img10,
    title: "Untitled 1",
    year: 2023,
    medium: "graphite",
    dimensions: "21x14.5",
    price: "£150",
    purchaseUrl: "https://buy.stripe.com/fZe5mS2hseOh5m8eV3",
  },
  {
    id: "img11",
    image: img11,
    title: "Foal",
    year: 2023,
    medium: "oil on gesso board",
    dimensions: "18x24",
    price: "sold",
  },
  {
    id: "img12",
    image: img12,
    title: "In the small valley",
    year: 2023,
    medium: "oil on canvas board",
    dimensions: "24x16",
    price: "sold",
  },
  {
    id: "img13",
    image: img13,
    title: "Memoriam",
    year: 2023,
    medium: "oil on wood",
    dimensions: "40x26.5",
    price: "£400",
    purchaseUrl: "https://buy.stripe.com/dR63eK8FQ35z29W8wG",
  },
  {
    id: "img14",
    image: img14,
    title: "Dartmoor",
    year: 2023,
    medium: "oil on canvas board",
    dimensions: "15 x 10",
    price: "sold",
  },
  {
    id: "img15",
    image: img15,
    title: "Pearl",
    year: 2023,
    medium: "oil on canvas board",
    dimensions: "22.5x14",
    price: "£100",
    purchaseUrl: "https://buy.stripe.com/eVag1w4pAgWp7ugcMZ",
  },
  {
    id: "img16",
    image: img16,
    title: "Untitled 2",
    year: 2023,
    medium: "oil on canvas board",
    dimensions: "39x26",
    price: "sold",
  },
  {
    id: "img17",
    image: img17,
    title: "Koenji",
    year: 2023,
    medium: "oil on wood",
    dimensions: "40x26.5",
    price: "sold",
  },
  {
    id: "img18",
    image: img18,
    title: "By my side",
    year: 2024,
    medium: "oil on canvas",
    dimensions: "40x26.5",
    price: "£400",
    purchaseUrl: "https://buy.stripe.com/28o6qW4pA21vaGs00f",
  },
  {
    id: "img19",
    image: img19,
    title:
      "As it was in the beginning, is now and ever shall be, world without end",
    year: 2024,
    medium: "oil on wood",
    dimensions: "40x26.5",
    price: "£400",
    purchaseUrl: "https://buy.stripe.com/9AQ6qWf4e35z6qcdR6",
  },
];

// Component for rendering individual artwork items
const ArtworkItem = ({ artwork, className, enlargedImage }) => {
  const [isEnlarged, setIsEnlarged] = useState(false);

  const handleImageClick = () => {
    if (window.innerWidth > 600) {
      setIsEnlarged(true);
    }
  };

  const closeEnlarged = () => {
    setIsEnlarged(false);
  };

  return (
    <>
      {/* <LazyLoad height={400} offset={100} once> */}
      <img
        className={className}
        src={artwork.image}
        alt={artwork.title}
        onClick={handleImageClick}
        style={{ cursor: window.innerWidth > 600 ? "pointer" : "default" }}
        loading="lazy"
      />
      {/* </LazyLoad> */}
      {isEnlarged && (
        <div className="image-overlay" onClick={closeEnlarged}>
          <img
            className="overlay-image"
            src={enlargedImage || artwork.image}
            alt={artwork.title}
          />
        </div>
      )}
      <div className="title1">
        <div style={{ fontSize: "1.1em" }}>« {artwork.title} »</div>
        <div>
          {artwork.year}, {artwork.medium}, {artwork.dimensions},{" "}
          {artwork.price}
          {artwork.purchaseUrl && (
            <>
              &nbsp;
              <Link
                className="linkToBuy"
                to={artwork.purchaseUrl}
                target="_blank"
                style={{ whiteSpace: "nowrap" }}
              >
                <span className="arrowShop">⭤</span>&nbsp;purchase
              </Link>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default function Shop() {
  return (
    <div className="shop">
      {artworks.map((artwork, index) => (
        <ArtworkItem
          key={artwork.id}
          artwork={artwork}
          className={artwork.id}
        />
      ))}

      <ArtworkItem
        artwork={{
          id: "img20",
          image: img20_2,
          title: "Tainte",
          year: 2024,
          medium:
            "oil on canvas, with pine and sapele tray frame made by Ralph Parks",
          dimensions: "39x26",
          price: "£500",
          purchaseUrl: "https://buy.stripe.com/bIYcPk7BM49DaGsbJ1",
        }}
        className="img20"
        enlargedImage={img20}
      />

      <ArtworkItem
        artwork={{
          id: "img21",
          image: img21,
          title: "Two",
          year: 2023,
          medium: "ball pen on paper",
          dimensions: "24x30",
          price: "£120",
          purchaseUrl: "https://buy.stripe.com/eVag1w7BMgWpg0M14m",
        }}
        className="img21"
      />
    </div>
  );
}
